
import { Dealer } from "@/types/dealer";
import { cacheService } from "@/lib/cacheService";

// Cache configuration
export const DEALERS_CACHE_KEY = 'dealers-list';
export const CACHE_EXPIRATION = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

/**
 * Helper functions for dealing with dealers cache
 */
export const dealersCache = {
  /**
   * Get dealers from cache if available and not expired
   */
  getDealers: (): Dealer[] | null => {
    const cacheEntry = cacheService.get<Dealer[]>(DEALERS_CACHE_KEY, CACHE_EXPIRATION);
    return cacheEntry ? cacheEntry.data : null;
  },
  
  /**
   * Store dealers in cache with expiration
   */
  setDealers: (dealers: Dealer[]): void => {
    cacheService.set(DEALERS_CACHE_KEY, dealers, { expiration: CACHE_EXPIRATION });
  },
  
  /**
   * Clear dealers cache
   */
  clearDealers: (): void => {
    cacheService.delete(DEALERS_CACHE_KEY);
  },
  
  /**
   * Get the timestamp when dealers were last cached
   */
  getLastUpdateTimestamp: (): number | null => {
    const cacheEntry = cacheService.get<Dealer[]>(DEALERS_CACHE_KEY);
    return cacheEntry ? cacheEntry.timestamp : null;
  }
};
